import NavigationPanel from "../navigation-panel";
import NavigationSection from "../../../core/model2/navigation/navigation-section";

// const debug = "navigation_clickSectionWhenMenuStatic"
const debug = false

export default function navigation_clickSectionWhenMenuStatic(navigationPanel: NavigationPanel, section: NavigationSection, resolve:callback, reject:callback) {

    debug && console.log(debug, "()", section)

    if (section.id === navigationPanel.state?.currentSection?.id) {  // yes by id
        debug && console.log(debug, "Same Section - do nothing")
        resolve(true)
        return
    }

    navigationPanel.setState({
        currentSection     : section
    },async ()=>{
        debug && console.log(debug, "navigation render done -> process menu")
        // resolve(true)

        debug && console.log(debug, "gd.layout.mainMenuStatic=", gd.layout.mainMenuStatic)

        if (gd.layout.mainMenuStatic) {
            await gd.layout.mainMenuStatic.reRender()
        } else {
            console.error("#LAYOUT-65 no menu component found")
        }

        resolve(true)
        return
    })


}
